import {ref} from "vue";
import Router from "@/router";

const router = ref(Router);
export default router;